export const SEAT_MONTHLY_USD = 100;

export const ANNUAL_DISCOUNT_RATE = 0.1;

export const ANNUAL_DISCOUNT_PERCENT = Math.round(ANNUAL_DISCOUNT_RATE * 100);

export const annualMonthlyUsd = (monthlyUsd: number): number => Math.round(monthlyUsd * (1 - ANNUAL_DISCOUNT_RATE));

export const SEAT_ANNUAL_MONTHLY_USD = annualMonthlyUsd(SEAT_MONTHLY_USD);

export const SEAT_ANNUAL_TOTAL_USD = SEAT_ANNUAL_MONTHLY_USD * 12;

export const SEAT_ANNUAL_SAVING_USD = SEAT_MONTHLY_USD * 12 - SEAT_ANNUAL_TOTAL_USD;

export const usd = (amount: number): string => `$${amount.toLocaleString("en-US")}`;

export type BillingPeriod = "monthly" | "annual";

export const seatPrice = (monthlyUsd: number): Record<BillingPeriod, string> => ({
  monthly: usd(monthlyUsd),
  annual: usd(annualMonthlyUsd(monthlyUsd)),
});

export const SEAT_PRICE: Record<BillingPeriod, string> = seatPrice(SEAT_MONTHLY_USD);

export const SEAT_PRICE_UNIT = "/ seat / month";

export const SEAT_BILLED_MONTHLY_NOTE = "Billed monthly. Cancel any time.";

export const SEAT_BILLED_ANNUAL_NOTE = {
  struck: usd(SEAT_MONTHLY_USD),
  rest: `billed annually — save ${ANNUAL_DISCOUNT_PERCENT}%`,
} as const;

export const SEAT_BILLED_NOTE: Record<BillingPeriod, string> = {
  monthly: SEAT_BILLED_MONTHLY_NOTE,
  annual: `${SEAT_BILLED_ANNUAL_NOTE.struck} ${SEAT_BILLED_ANNUAL_NOTE.rest}`,
};

export const ANNUAL_SAVE_CHIP = `save ${ANNUAL_DISCOUNT_PERCENT}%`;

export const ANNUAL_DISCOUNT_ANSWER = `Annual billing takes ${ANNUAL_DISCOUNT_PERCENT}% off the monthly rate: ${usd(SEAT_ANNUAL_MONTHLY_USD)} per seat per month instead of ${usd(SEAT_MONTHLY_USD)}, charged once a year at ${usd(SEAT_ANNUAL_TOTAL_USD)} per seat. Monthly billing stays flexible — cancel whenever you like.`;
